import {Component, EventEmitter, OnDestroy, Output} from '@angular/core';
import {UtilService, CountdownTimerService, CountdownTick} from "library";
import {HttpResponse, HttpErrorResponse, HttpStatusCode} from '@angular/common/http';
import {ActivatedRoute} from "@angular/router";
import {CustomMessageService} from "library";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {SalesWorkflowService} from "projects/store/src/app/services/api/v1/sales-workflow.service";
import { Subject, takeUntil } from 'rxjs';

const TITLE_INIT = "Hemos iniciado el proceso para otorgar el crédito";
const TITLE_ANNULMENT = "Hemos iniciado el proceso para ANULAR la transacción anterior";
const TITLE_INIT_REG = "El código anterior se ha vencido";

const SUB_TITLE_INIT = "Ahora, ve a la caja para digitar el siguiente <strong>OTP</strong> en el datáfono:";
const SUB_TITLE_AFTER_INIT = "Estamos generando el <strong>OTP</strong>. Por favor, esperar";
const SUB_TITLE_INIT_PROGRESS = "Estamos generando el OTP a usar. Por favor, espera, este proceso puede durar alrededor de 5 minutos.";

const TEXT_LOADING_PROGRESS = "Esperando OTP";
const TEXT_LOADING_WAIT = "Esperando confirmación";

const TIME_RETRY = 120;

export enum OtpActionRetry {
  getOtp = 'getOtp',
  getStatus = 'getStatus',
  reGetOtp = 'reGetOtp'
}
@Component({
  selector: 'app-sales-claro-credibanco',
  templateUrl: './sales-claro-credibanco.component.html',
})

export class SalesClaroCredibancoComponent implements OnDestroy {
  status: number = 0;
  statusReGetOtp: number = 0;
  visibleModal = false;
  loading = false;
  requestId: string;
  otpCode: string = '';
  messageError: string = '';
  flowCode: string = this.route.snapshot.params['flow_code'];
  showContainerInProgress: boolean = false;
  showContainerRetry: boolean = false;
  showContainerCode: boolean = false;
  showScreenCancel: boolean = false;
  // Modal para mostrar cuando la anulación se completa exitosamente
  showModalAnnulmentSuccess: boolean = false;
  otpActionRetry: OtpActionRetry = OtpActionRetry.getOtp;
  @Output() nextStepEvent = new EventEmitter();
  private readonly FIRST_POLLING_DELAY_MS: number = 120000; // 2 minutos
  private readonly DEFAULT_POLLING_DELAY_MS: number = 15000; // 15 segundos
  titleInit: string = TITLE_INIT;
  subTitleInit: string = SUB_TITLE_INIT;
  textLoading: string = TEXT_LOADING_WAIT;

  // Flag para indicar si el request es de cancelación (anulación) o venta normal
  cancelOTPRequest: boolean = false;
  // Flag para controlar si el polling de status está activo, permite detenerlo cuando sea necesario
  pollActiveStatus: boolean = false;
  // Array para almacenar referencias de setTimeout y poder limpiarlos en ngOnDestroy (previene memory leaks)
  private timeouts: any[] = [];

  timeNewCodeSending!: { minutes: number, seconds: number };
  private countdownSub: any;
  private finishedSub: any;
  private destroy$ = new Subject<void>();
  buttonEnabled = false;

  constructor(
    private utilService: UtilService,
    private route: ActivatedRoute,
    private requestService: RequestService,
    private salesWorkflowService: SalesWorkflowService,
    private countdownTimer: CountdownTimerService,
    private customMessageService: CustomMessageService
  ) {
    this.requestId = this.route.snapshot.params['request_id'];
  }

  ngOnInit() {
    this.getOtp();
  }

  getOtp() {

    this.closeAllContainers();
    this.loading = true;
    this.textLoading = TEXT_LOADING_PROGRESS;
    this.subTitleInit = SUB_TITLE_AFTER_INIT;
    this.showContainerCode = true;
    this.utilService.disablePageLoading();

    this.requestService.generateOtpPointOfSales(this.requestId)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (resp: HttpResponse<any>) => {
        this.utilService.disablePageLoading();
        switch (resp.status) {
          // Caso 200: El OTP ya fue utilizado previamente, mostrar éxito directo
          case HttpStatusCode.Ok:
            this.closeAllContainers();
            this.loading = false;
            this.visibleModal = true;
            this.stopPollStatus();
            break;

          // Caso 202: Flujo de anulación, se genera OTP para anular transacción anterior
          case HttpStatusCode.Accepted:
            this.closeAllContainers();
            this.titleInit = TITLE_ANNULMENT;
            this.subTitleInit = SUB_TITLE_INIT;
            this.otpCode = resp.body.data.otp_code_anular;
            this.textLoading = TEXT_LOADING_WAIT;
            this.loading = true;
            this.showContainerCode = true;
            // Iniciar polling después de 15 segundos y guardar referencia
            {
              const id = setTimeout(() => this.observableStatusOtp(), this.DEFAULT_POLLING_DELAY_MS);
              this.timeouts.push(id);
            }
            break;

          // Caso 201: OTP creado exitosamente, mostrar código e iniciar polling
          case HttpStatusCode.Created:
            this.otpCode = resp.body.data.otp_code;
            this.textLoading = TEXT_LOADING_WAIT;
            this.subTitleInit = SUB_TITLE_INIT;
            // Guardar referencia del timeout para limpieza posterior
            {
              const id = setTimeout(() => {this.observableStatusOtp();}, this.DEFAULT_POLLING_DELAY_MS);
              this.timeouts.push(id);
            }
            break;

          // Caso 206: OTP en proceso de generación, reintentar después de 15 segundos
          case HttpStatusCode.PartialContent:
            this.loading = true;
            this.textLoading = TEXT_LOADING_PROGRESS;
            this.titleInit = TITLE_INIT;
            this.subTitleInit = SUB_TITLE_INIT_PROGRESS;
            this.showContainerCode = true;
            // Guardar referencia del timeout para limpieza posterior
            {
              const id = setTimeout(() => this.getOtp(), this.DEFAULT_POLLING_DELAY_MS);
              this.timeouts.push(id);
            }
            break;

          default:
            this.customMessageService.responseNoticeHandler(resp)
          }
      },
      error: (error: HttpErrorResponse) => {
        this.utilService.disablePageLoading();
        switch (error.status) {
          // Caso 406: No se pudo generar OTP, mostrar pantalla de reintento con timer
          case HttpStatusCode.NotAcceptable:
            this.closeAllContainers();
            this.startCountdown();
            this.showContainerRetry = true;
            this.otpActionRetry = OtpActionRetry.getOtp;
            break;
          // Caso 409: Conflicto, la solicitud está bloqueada
          case HttpStatusCode.Conflict:
            this.closeAllContainers();
            this.showScreenCancel = true;
            this.customMessageService.logErrorOnly(error)
            break;
        }
      }
    });
  }

  observableStatusOtp() {
    let attempt = 0;
    // Activar flag de polling para poder controlar su ejecución
    this.pollActiveStatus = true;

    const poll = () => {
      // Verificar si el polling sigue activo antes de continuar
      if (!this.pollActiveStatus) { return; }

      this.requestService.getStatusOtpPointOfSales(this.requestId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (resp) => {
          this.utilService.disablePageLoading();
          this.status = resp.status;
          switch (this.status) {
            // Caso 200: OTP confirmado exitosamente
            case HttpStatusCode.Ok:
              this.closeAllContainers();
              this.loading = false;
              this.visibleModal = true;
              this.stopPollStatus();
              break;

            // Caso 202: Anulación confirmada exitosamente, detener polling y reiniciar flujo
            case HttpStatusCode.Accepted:
              this.otpCode = '';
              this.closeAllContainers();
              this.stopPollStatus();
              this.showModalAnnulmentSuccess = true;
              break;

            // Caso 206: Proceso aún en progreso, continuar polling con delays variables
            case HttpStatusCode.PartialContent:
              if (this.pollActiveStatus) {
                attempt++;
                // Primer intento: esperar 2 minutos, siguientes intentos: 15 segundos
                const nextDelay = attempt === 1 ? this.FIRST_POLLING_DELAY_MS : this.DEFAULT_POLLING_DELAY_MS;
                // Guardar referencia del timeout para limpieza posterior
                const id = setTimeout(poll, nextDelay);
                this.timeouts.push(id);
              }
              break;

            default:
              this.customMessageService.responseNoticeHandler(resp);
            }

          },
          error: (error) => {
            // Detener polling cuando ocurre un error
            this.stopPollStatus();
            this.utilService.disablePageLoading();

            switch (error.status) {
              // Caso 406: Error al obtener status, mostrar pantalla de reintento
              case HttpStatusCode.NotAcceptable:
                this.closeAllContainers();
                this.showContainerRetry = true;
                this.startCountdown();
                this.otpActionRetry = OtpActionRetry.getStatus;
              break;
              // Caso 422: OTP vencido, regenerar automáticamente
              case HttpStatusCode.UnprocessableEntity:
                  this.reGetOtp();
                break;
              default:
                this.customMessageService.responseNoticeHandler(error);
            }
          }
      });
    };
    poll();
  }

  reGetOtp() {

    this.closeAllContainers();
    this.titleInit = TITLE_INIT_REG;
    this.subTitleInit = SUB_TITLE_AFTER_INIT;
    this.textLoading = TEXT_LOADING_PROGRESS;
    this.loading = true;
    this.showContainerCode = true;
    this.utilService.disablePageLoading();

    this.requestService.reGenerateOtpPointOfSales(this.requestId)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (resp) => {
        this.utilService.disablePageLoading();
        this.statusReGetOtp = resp.status;
        switch (this.statusReGetOtp) {
          // Caso 201: Nuevo OTP generado exitosamente tras vencimiento del anterior
          case HttpStatusCode.Created:
            this.otpCode = resp.body.data.otp_code;
            this.subTitleInit = SUB_TITLE_INIT;
            this.textLoading = TEXT_LOADING_WAIT;
            this.observableStatusOtp();
            break;
          default:
            break;
        }
      },
      error: (error) => {
        this.statusReGetOtp = error.status;
        this.utilService.disablePageLoading();
        switch (this.statusReGetOtp) {
          // Caso 406: No se pudo regenerar OTP, mostrar pantalla de reintento
          case HttpStatusCode.NotAcceptable:
            this.closeAllContainers();
            this.showContainerRetry = true;
            this.otpActionRetry = OtpActionRetry.reGetOtp;
            this.startCountdown();
            break;
          // Caso 409: Conflicto, la solicitud está bloqueada
          case HttpStatusCode.Conflict:
            this.closeAllContainers();
            this.showScreenCancel = true;
            break;
          default:
            this.customMessageService.responseNoticeHandler(error);
            break;
        }
      }
    });
  }

  onNextStep() {
    this.visibleModal = false;
    this.utilService.enablePageLoading();
    this.nextStepEvent.emit();
  }

  // Método para detener el polling de status OTP
  stopPollStatus() {
    this.pollActiveStatus = false;
  }

  onRetry(){
    this.utilService.enablePageLoading();
    this.messageError = '';
    this.closeAllContainers();
    switch (this.otpActionRetry) {
      case OtpActionRetry.getOtp:
        this.getOtp();
        break;
      case OtpActionRetry.reGetOtp:
        this.reGetOtp();
        break;
      case OtpActionRetry.getStatus:
        this.observableStatusOtp();
        break;
    }

  }

  startCountdown() {
    this.buttonEnabled = false;
    // Cancelar suscripciones previas
    this.countdownSub?.unsubscribe?.();
    this.finishedSub?.unsubscribe?.();
    // Calcular duración desde TIME_RETRY (segundos)
    const duration = { minutes: Math.floor(TIME_RETRY / 60), seconds: TIME_RETRY % 60 };
    this.timeNewCodeSending = { ...duration };
    // Iniciar servicio
    this.countdownTimer.startWithDuration(duration);
    // Suscribir ticks y finalización
    this.countdownSub = this.countdownTimer.tick$.subscribe((tick: CountdownTick) => {
      this.timeNewCodeSending = { ...tick };
    });
    this.finishedSub = this.countdownTimer.finished$.subscribe(() => {
      this.buttonEnabled = true;
    });
  }

  get formattedTime(): string {
    const minutes = (this.timeNewCodeSending?.minutes ?? 0).toString().padStart(2, '0');
    const seconds = (this.timeNewCodeSending?.seconds ?? 0).toString().padStart(2, '0');
    return `${minutes}:${seconds} segundos`;
  }

  closeAllContainers() {
    this.showContainerInProgress = false;
    this.showContainerRetry = false;
    this.showContainerCode = false;
    this.showScreenCancel = false;
    // Cerrar todos los modales para evitar que queden abiertos
    this.visibleModal = false;
    this.showModalAnnulmentSuccess = false;
    this.messageError = '';
  }


  getCanCancelRequest(): boolean {
    return this.salesWorkflowService.canCancelRequest();
  }

  ngOnDestroy() {
    // Detener el polling activo para evitar requests innecesarios
    this.stopPollStatus();

    // Desuscribir del countdown timer
    this.countdownSub?.unsubscribe?.();
    this.finishedSub?.unsubscribe?.();
    this.countdownTimer.stop();

    // Limpiar todos los timeouts pendientes para prevenir memory leaks
    if (this.timeouts && this.timeouts.length) {
      this.timeouts.forEach(id => clearTimeout(id));
      this.timeouts = [];
    }

    // Completar el Subject destroy$ para cancelar todas las suscripciones activas
    this.destroy$.next();
    this.destroy$.complete();
  }
}
